import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Activity, BarChart3, CreditCard, Route, Shield, Zap } from 'lucide-react';
import DashboardLayout from '../components/DashboardLayout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { useAuth } from '../context/AuthContext';
import OverviewTab from '../components/admin/OverviewTab';
import RoutingTab from '../components/admin/RoutingTab';
import CreditsAdminTab from '../components/admin/CreditsAdminTab';
import HealthTab from '../components/admin/HealthTab';
import StripeTab from '../components/admin/StripeTab';

const TABS = [
  { value: 'overview', label: 'Overview', icon: BarChart3, component: OverviewTab },
  { value: 'routing', label: 'AI routing', icon: Route, component: RoutingTab },
  { value: 'credits', label: 'Credits', icon: Zap, component: CreditsAdminTab },
  { value: 'health', label: 'Health & alerts', icon: Activity, component: HealthTab },
  { value: 'billing', label: 'Stripe', icon: CreditCard, component: StripeTab },
];

/** Admin dashboard: margins, AI routing, credit prices, model health and Stripe status (admins only). */
const AdminPage = () => {
  const { user } = useAuth();
  const location = useLocation();
  if (user && !user.is_admin) return <Navigate to="/dashboard" replace />;
  const requested = new URLSearchParams(location.search).get('tab');
  const initialTab = TABS.some((t) => t.value === requested) ? requested : 'overview';

  return (
    <DashboardLayout>
      <div className="p-6 lg:p-8" data-testid="admin-page">
        <div className="mx-auto max-w-7xl space-y-6">
          <header className="space-y-1">
            <h1 className="flex items-center gap-2 text-2xl font-bold text-slate-900">
              <Shield className="h-6 w-6 text-emerald-500" />Admin
            </h1>
            <p className="text-slate-600">AI platform operations: costs, routing, credits, health and billing.</p>
          </header>
          <Tabs defaultValue={initialTab} className="space-y-6">
            <TabsList className="h-auto flex-wrap justify-start gap-1 bg-slate-100 p-1">
              {TABS.map(({ value, label, icon: Icon }) => (
                <TabsTrigger key={value} value={value} className="gap-2 px-3 py-1.5">
                  <Icon className="h-4 w-4" />{label}
                </TabsTrigger>
              ))}
            </TabsList>
            {TABS.map(({ value, component: Component }) => (
              <TabsContent key={value} value={value} className="mt-0"><Component /></TabsContent>
            ))}
          </Tabs>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default AdminPage;
